module.exports = __webpack_public_path__ + "img/trash-icon.40ee8186.svg";